export default __webpack_public_path__ + "static/media/hamburger.6572e529.svg";